import request from '@/utils/http'

const PREFIX = '/group/user'
// 用户分群
const userGroup = {
  create(params) {
    return request(
      `${PREFIX}`,
      'post',
      params
    )
  },

  edit(id, params) {
    return request(
      `${PREFIX}/${id}`,
      'put',
      params
    )
  },

  isDynamicTime(id, params) {
    return request(
      `${PREFIX}/isDynamicTime/${id}`,
      'put',
      params
    )
  },

  update(id) {
    return request(
      `${PREFIX}/updateUser/${id}`,
      'put',
    )
  },

  delete(id) {
    return request(
      `${PREFIX}/${id}`,
      'delete',
    )
  },

  pageGroup(params) {
    return request(
      `${PREFIX}/page/group`,
      'get',
      params
    )
  },

  pageGroupUser(id, params) {
    return request(
      `${PREFIX}/page/groupUser/${id}`,
      'get',
      params
    )
  },

  pageBehavior(params) {
    return request(
      `${PREFIX}/page/behavior`,
      'post',
      params
    )
  }
}

export default userGroup
